import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="980" viewBox="0 0 100% 480" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0%" y="10px" width="60%" height="40px" rx="2" />
            <rect x="0%" y="90px" width="8%" height="40px" rx="2" />
            <rect x="11%" y="102px" width="100%" height="18px" rx="2" />
            <rect x="0%" y="180px" width="20%" height="14px" rx="2" />
            <rect x="50%" y="180px" width="20%" height="14px" rx="2" />
            <rect x="0%" y="214px" width="45%" height="42px" rx="2" />
            <rect x="50%" y="214px" width="90%" height="42px" rx="2" />
            <rect x="0%" y="274px" width="20%" height="14px" rx="2" />
            <rect x="0%" y="302px" width="15%" height="14px" rx="2" />
            <rect x="20%" y="302px" width="15%" height="14px" rx="2" />
            <rect x="50%" y="302px" width="18%" height="14px" rx="2" />
            <rect x="0%" y="338px" width="15%" height="42px" rx="2" />
            <rect x="20%" y="338px" width="25%" height="42px" rx="2" />
            <rect x="50%" y="338px" width="20%" height="42px" rx="2" />
            <rect x="0%" y="400px" width="12%" height="14px" rx="2" />
            <rect x="0%" y="434px" width="100%" height="42px" rx="2" />
            <rect x="0%" y="496px" width="20%" height="14px" rx="2" />
            <rect x="0%" y="530px" width="50%" height="42px" rx="2" />
            <rect x="0%" y="592px" width="30%" height="14px" rx="2" />
            <rect x="0%" y="626px" width="50%" height="42px" rx="2" />
            <rect x="0%" y="688px" width="50%" height="14px" rx="2" />
            <rect x="0%" y="722px" width="60%" height="42px" rx="2" />
            <rect x="0%" y="784px" width="60%" height="14px" rx="2" />
            <rect x="0%" y="818px" width="100%" height="42px" rx="2" />
        </g>
    </svg>
);

const AddFamilyModalLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default AddFamilyModalLoadingIndicator;
